<div [formGroup]="form()">
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-4">
      <h4 class="text-base font-medium text-gray-12">Stationnement</h4>
      <div class="flex flex-col gap-2">
        <span class="text-sm text-gray-11">Y a-t-il un stationnement ?</span>
        <mat-button-toggle-group formControlName="parkingAvailable" aria-label="Stationnement" class="w-1/3">
          <mat-button-toggle class="w-1/2" [value]="true">Oui</mat-button-toggle>
          <mat-button-toggle class="w-1/2" [value]="false">Non</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      @if (form().controls.parkingAvailable.value) {
        <div class="mt-2 flex flex-col gap-6">
          <div class="divide-y divide-gray-6">
            @for (control of parkings.controls; track control) {
              @let type = control.controls.type.value;
              <div
                [formGroup]="control"
                class="flex flex-col gap-4 py-6 first:pt-0 last:pb-0 md:flex-row md:items-end"
              >
                <div class="flex flex-1 flex-col gap-1">
                  <span class="text-sm font-medium text-gray-12">{{
                    type | etxeEnumDisplay: 'parking'
                  }}</span>
                  <aura-number-input
                    label="Quantité"
                    [value]="control.controls.count.value ?? undefined"
                    (valueChange)="control.controls.count.setValue($event ?? 0)"
                    [min]="1"
                  ></aura-number-input>
                </div>

                <mat-form-field appearance="outline" class="flex-1" subscriptSizing="dynamic">
                  <mat-label>Surface totale</mat-label>
                  <input matInput type="number" min="0" formControlName="totalSurface" placeholder="0" />
                  <span matSuffix class="mr-2">m²</span>
                </mat-form-field>

                @if (showLotNumber()) {
                  <mat-form-field appearance="outline" class="flex-1" subscriptSizing="dynamic">
                    <mat-label>Numéro de lot</mat-label>
                    <input matInput formControlName="lotNumber" placeholder="Ex: 12" />
                  </mat-form-field>
                }

                @if (type) {
                  <button
                    mat-icon-button
                    type="button"
                    (click)="toggleParkingType(type)"
                    matTooltip="Supprimer ce type"
                    class="text-ruby-11 hover:bg-ruby-a3"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            }
          </div>

          <div class="flex flex-col gap-3">
            <span class="text-xs font-semibold tracking-wider text-gray-10 uppercase"
              >Ajouter un type de stationnement</span
            >
            <div class="flex flex-wrap gap-2">
              @for (type of parkingTypes; track type) {
                @if (!isParkingSelected(type)) {
                  <button
                    mat-stroked-button
                    type="button"
                    (click)="toggleParkingType(type)"
                    class="rounded-full"
                  >
                    <mat-icon class="mr-1">add</mat-icon>
                    {{ type | etxeEnumDisplay: 'parking' }}
                  </button>
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
